import React, { Dispatch, PropsWithChildren, createContext, useState } from "react";

import IUserEvent from "./types/IUserEvent";

export interface EventContextProps {
  /** The most recent user event that occurred. */
  userEvent: IUserEvent<unknown> | null;
  /** Dispatches a user event for consumption by listeners. */
  onUserEvent: Dispatch<IUserEvent<unknown>>;
}

export const EventContextProvider = ({ children }: PropsWithChildren): React.JSX.Element => {
  const [userEvent, setUserEvent] = useState<IUserEvent<unknown> | null>(null);

  return <EventContext.Provider value={{ userEvent, onUserEvent: setUserEvent }}>{children}</EventContext.Provider>;
};

const EventContext = createContext({} as EventContextProps);

export default EventContext;
